import styled from 'styled-components';

import { useClickAttachment } from 'hooks/useClickAttachment';
import { SummaryAttachment } from 'models/aiArtifacts/Summary';
import colors from 'styles/theme/colors';

import CitationBadge from './CitationBadge';

export default function SourceChip({ attachment }: { attachment: SummaryAttachment }) {
  const handleClick = useClickAttachment(attachment.attachmentId);

  return (
    <StyledBadge onClick={handleClick}>
      <CitationBadge attachment={attachment} clickable={false} hideHoverEffect />
      {attachment.filename}
    </StyledBadge>
  );
}

const StyledBadge = styled.span`
  background-color: ${colors.black03};
  color: ${colors.black};
  height: 32px;
  padding: 8px 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 2%;
  border-radius: 43px;
  cursor: pointer;

  * {
    cursor: pointer;
  }

  &:hover {
    border: 1px solid #5e42e1;
    padding: 7px 11px;
  }
`;
